import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

function CancelConfirmButtons(props) {
  return (
    <div className="actions col-12 inline-container space-between">
      <button
        type="button"
        className="large secondary inline-container"
        onClick={props.onClose}
        data-id="cancel"
      >
        <Icon icon="go-back"/>
        <Translate value="action.cancel"/>
      </button>
      <button
        className="large primary inline-container"
        id="submit"
        type="submit"
        disabled={props.submitting}
      >
        <Icon icon={props.submitting ? 'loader' : 'check'}/>
        <Translate value="action.confirm"/>
      </button>
    </div>
  );
}

CancelConfirmButtons.defaultProps = {
  submitting: false
};

CancelConfirmButtons.propTypes = {
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export default CancelConfirmButtons;
